import styled from "styled-components";

export default styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    height: fit-content;
    display: block;

    .chat-menu {
      position: relative;
      width: 100%;
    }
  }
`;
